<template>
  <div v-if="user">
    <div
      class="mt-2 w-100 px-2"
      v-if="user"
      :class="{
        'dashboard-container':
          user.group_names.includes('PROFESORES') ||
          user.group_names.includes('ESTUDIANTES'),
        'notification-dashboard':
          !user.group_names.includes('PROFESORES') &&
          !user.group_names.includes('ESTUDIANTES'),
      }"
    >
      <!-- <klv3-rich-text-component
        :initial-content="textFromVue2"
        @send-content="handleSendContent"
      ></klv3-rich-text-component> -->
      <!-- TODO: Comentado hasta Terminar trabajo en Evaluaciones. -->
      <!-- :class="{ 'dashboard-container': user.is_professor || user.is_student }" -->
      <!-- ===== Mensaje de bienvenida (usuarios sin rol académico) ===== -->
      <div v-if="showWelcomeMessage" class="kl-welcome-wrapper">
        <div class="kl-welcome">
          <div class="kl-welcome__badge">
            <b-icon icon="person-fill"></b-icon>
          </div>
          <h2 class="kl-welcome__title">
            {{
              $t("dashboard.dashboardView.welcomeToPlatformTitle", {
                name: `${user.first_name} ${user.last_name}`,
              })
            }}
          </h2>
          <div class="kl-welcome__divider"></div>
          <p class="kl-welcome__text">
            {{ $t("dashboard.dashboardView.welcomeToPlatformDescription") }}
          </p>
          <div class="kl-welcome__hint">
            <b-icon
              icon="arrow-left-circle-fill"
              class="kl-welcome__hint-icon"
            ></b-icon>
            <span>{{
              $t("dashboard.dashboardView.welcomeToPlatformHint")
            }}</span>
          </div>
        </div>
      </div>
      <div class="left-container">
        <!-- ===== Dashboard del Profesor: resumen (KPIs) que actúan como pestañas ===== -->
        <div
          v-if="user.group_names.includes('PROFESORES')"
          class="teacher-dash"
        >
          <div class="kpi-row noprint">
            <button
              v-for="tab in teacherTabs"
              :key="tab.key"
              type="button"
              class="kpi-tile"
              :class="{ 'is-active': activeTeacherTab === tab.key }"
              @click="activeTeacherTab = tab.key"
            >
              <div class="d-flex">
                <span class="kpi-tile__icon mr-3">
                  <b-icon :icon="tab.icon"></b-icon>
                </span>
                <span class="kpi-tile__value">{{
                  teacherCounts[tab.key]
                }}</span>
              </div>
              <span class="kpi-tile__label">{{ tab.label }}</span>
            </button>
          </div>
          <div class="teacher-dash__panel">
            <!-- Notificaciones (instrumentos sin fecha por asignar) -->
            <div v-show="activeTeacherTab === 'notifications'">
              <Card class="dashboard-card" :hide_title="true">
                <template v-slot:content>
                  <template
                    v-if="next_evaluation_teacher_notification.length > 0"
                  >
                    <div class="text-left d-flex">
                      <div>⚠️</div>
                      <div class="notification-text">
                        {{ $t("dashboard.dashboardView.has") }}
                        <strong
                          class="div-href-test"
                          @click="
                            $bvModal.show(`notification-test-without-time`)
                          "
                        >
                          {{ next_evaluation_teacher_notification.length }}
                          {{
                            $getVisibleNames(
                              "evaluations2.test",
                              next_evaluation_teacher_notification.length > 1,
                              "Instrumentos"
                            )
                          }}
                        </strong>
                        {{ $t("dashboard.dashboardView.withoutDate") }}
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-left p-1">
                      {{ $t("dashboard.dashboardView.noNotifications") }}
                    </div>
                  </template>
                </template>
              </Card>
            </div>
            <!-- Mis Clases -->
            <div v-show="activeTeacherTab === 'current'">
              <CurrentSectionTeacher
                :hide_title="true"
                @count="teacherCounts.current = $event"
              ></CurrentSectionTeacher>
            </div>
            <!-- Próximas Evaluaciones -->
            <div v-show="activeTeacherTab === 'next'">
              <NextTestTeacher
                :key="key_notification + 'nt'"
                :hide_title="true"
                @count="teacherCounts.next = $event"
              ></NextTestTeacher>
            </div>
            <!-- Por Corregir -->
            <div v-show="activeTeacherTab === 'correct'">
              <InstrumentCorrection
                :key="key_notification_instrument_correction + 'ic'"
                :hide_title="true"
                @count="teacherCounts.correct = $event"
              ></InstrumentCorrection>
            </div>
            <!-- Clases Pasadas -->
            <div v-show="activeTeacherTab === 'past'">
              <PastSectionTeacher
                :hide_title="true"
                @count="teacherCounts.past = $event"
              ></PastSectionTeacher>
            </div>
          </div>
        </div>

        <!-- ===== Dashboard del Estudiante: resumen (KPIs) que actúan como pestañas ===== -->
        <div
          v-if="user.group_names.includes('ESTUDIANTES')"
          class="teacher-dash"
        >
          <div class="kpi-row noprint">
            <button
              v-for="tab in studentTabs"
              :key="tab.key"
              type="button"
              class="kpi-tile"
              :class="{ 'is-active': activeStudentTab === tab.key }"
              @click="activeStudentTab = tab.key"
            >
              <div class="d-flex">
                <span class="kpi-tile__icon mr-3">
                  <b-icon :icon="tab.icon"></b-icon>
                </span>
                <span class="kpi-tile__value">{{
                  studentCounts[tab.key]
                }}</span>
              </div>
              <span class="kpi-tile__label">{{ tab.label }}</span>
            </button>
            <!-- Tile de acción: navega a "Mis Notas" (no cambia de pestaña) -->
            <button
              v-if="institution && institution.kl_assessment"
              type="button"
              class="kpi-tile kpi-tile--action"
              @click="
                $router.push({ name: 'StudentGradeView' }).catch(() => {})
              "
            >
              <span class="kpi-tile__icon">
                <b-icon icon="bar-chart-line-fill"></b-icon>
              </span>
              <span class="kpi-tile__action-text">{{
                $t("dashboard.dashboardView.myGrades")
              }}</span>
            </button>
          </div>
          <div class="teacher-dash__panel">
            <!-- Mis Clases -->
            <div v-show="activeStudentTab === 'current'">
              <CurrentSectionStudent
                :hide_title="true"
                @count="studentCounts.current = $event"
              ></CurrentSectionStudent>
            </div>
            <!-- Próximas Evaluaciones -->
            <div v-show="activeStudentTab === 'next'">
              <NextTestStudent
                :hide_title="true"
                @count="studentCounts.next = $event"
              ></NextTestStudent>
            </div>
            <!-- Evaluaciones Finalizadas -->
            <div v-show="activeStudentTab === 'finished'">
              <PublishTestStudent
                :hide_title="true"
                @count="studentCounts.finished = $event"
              ></PublishTestStudent>
            </div>
            <!-- Clases Pasadas -->
            <div v-show="activeStudentTab === 'past'">
              <PastSectionStudent
                :hide_title="true"
                @count="studentCounts.past = $event"
              ></PastSectionStudent>
            </div>
          </div>
        </div>

        <!-- ===== Dashboard del Directivo: resumen (KPIs) que actúan como pestañas ===== -->
        <div v-if="showDirectiveDashboard" class="teacher-dash">
          <div class="kpi-row noprint">
            <button
              v-for="tab in directiveTabs"
              :key="tab.key"
              type="button"
              class="kpi-tile"
              :class="{ 'is-active': activeDirectiveTab === tab.key }"
              @click="activeDirectiveTab = tab.key"
            >
              <div class="d-flex">
                <span class="kpi-tile__icon mr-3">
                  <b-icon :icon="tab.icon"></b-icon>
                </span>
                <span class="kpi-tile__value">{{
                  directiveCounts[tab.key]
                }}</span>
              </div>
              <span class="kpi-tile__label">{{ tab.label }}</span>
            </button>
          </div>
          <div class="teacher-dash__panel">
            <!-- Perfiles de Egreso con Secciones activas (tabla actual). No se
            muestra en Duoc. -->
            <div
              v-if="institution && institution.internal_use_id != 'duoc.cl'"
              v-show="activeDirectiveTab === 'careers'"
            >
              <DirectiveDashboard
                @count="directiveCounts.careers = $event"
              ></DirectiveDashboard>
            </div>
            <!-- Nuevo panel de Perfiles de Egreso -->
            <div v-show="activeDirectiveTab === 'egress'">
              <DashboardEgressProfile
                @count="directiveCounts.egress = $event"
              ></DashboardEgressProfile>
            </div>
            <!-- Asignaturas con Secciones activas -->
            <div v-show="activeDirectiveTab === 'matters'">
              <DashboardActiveMatters
                @count="directiveCounts.matters = $event"
              ></DashboardActiveMatters>
            </div>
          </div>
        </div>
      </div>
      <!-- TODO: Comentado hasta Terminar trabajo en Evaluaciones. -->
      <!-- :class="{ 'right-container': user.is_professor || user.is_student }" -->
      <div
        :class="{
          'ml-2 right-container':
            user.group_names.includes('PROFESORES') ||
            user.group_names.includes('ESTUDIANTES'),
        }"
      >
        <!-- -------------------------Notificaciones------------------------- -->
        <!-- La tarjeta visible de Notificaciones se movió al teacher-dash como
        pestaña/KPI. Aquí solo queda el modal (teleportado) para poder abrirlo. -->
        <template v-if="user && user.group_names.includes('PROFESORES')">
          <b-modal
            :id="`notification-test-without-time`"
            :hide-footer="true"
            :title="
              $t('dashboard.dashboardView.assignDatesToRemainingEntities', {
                entity: $getVisibleNames(
                  'evaluations2.evaluation',
                  true,
                  'Evaluaciones'
                ),
              })
            "
            size="xl"
          >
            <template>
              <div
                v-if="
                  next_evaluation_teacher_notification.length != 0 ||
                  optionsMatterNotificationTest.length > 1 ||
                  optionsCareerNotificationTest.length > 1 ||
                  optionsSectionNotificationTest.length > 1 ||
                  optionsCampuNotificationTest.length > 1
                "
                class="container-select mb-2"
              >
                <div>
                  <b-form-select
                    id="input-campus"
                    class="select-form"
                    v-model="select_campus_notification_test"
                    :options="optionsCampuNotificationTest"
                  ></b-form-select>
                </div>
                <div>
                  <b-form-select
                    id="input-career"
                    class="select-form"
                    v-model="select_career_notification_test"
                    :options="optionsCareerNotificationTest"
                  ></b-form-select>
                </div>
                <div>
                  <b-form-select
                    id="input-matter"
                    class="select-form"
                    v-model="select_matter_notification_test"
                    :options="optionsMatterNotificationTest"
                  ></b-form-select>
                </div>
                <div>
                  <b-form-select
                    id="input-section"
                    class="select-form"
                    v-model="select_section_correct_test"
                    :options="optionsSectionNotificationTest"
                  ></b-form-select>
                </div>
              </div>
              <b-table-simple
                hover
                sticky-header="500px"
                class="border-table-notification"
              >
                <b-thead>
                  <b-tr>
                    <!-- Columna Nombre Evaluacion (Evaluacion)-->
                    <b-th
                      class="primary-cell-next-test-notification text-center"
                      style="width: 11%"
                    >
                      {{
                        $getVisibleNames(
                          "evaluations2.evaluation",
                          false,
                          "Evaluación"
                        )
                      }}
                    </b-th>
                    <!-- Columna Nombre Evaluacion (Test) -->
                    <b-th
                      class="primary-cell-next-test-notification text-center"
                      style="width: 11%"
                    >
                      <!-- {{
                        $getVisibleNames(
                          "teaching.evaluationsituation",
                          false,
                          "Situación Evaluativa"
                        )
                      }} -->
                      {{
                        $getVisibleNames(
                          "evaluations2.test",
                          false,
                          "Instrumento"
                        )
                      }}
                    </b-th>
                    <b-th
                      class="primary-cell-next-test-notification text-center"
                      style="width: 9%"
                    >
                      {{ $getVisibleNames("mesh.campus", false, "Sede") }}
                    </b-th>
                    <b-th
                      class="primary-cell-next-test-notification text-center"
                      style="width: 11%"
                    >
                      {{ $getVisibleNames("mesh.career", false, "Programa") }}
                    </b-th>
                    <b-th
                      class="primary-cell-next-test-notification text-center"
                      style="width: 11%"
                      >{{
                        $getVisibleNames(
                          "mesh.egressprofilematter",
                          false,
                          "Asignatura"
                        )
                      }}</b-th
                    >
                    <b-th
                      class="primary-cell-next-test-notification text-center"
                      style="width: 7%"
                    >
                      {{
                        $getVisibleNames("teaching.section", false, "Sección")
                      }}
                    </b-th>
                    <b-th
                      class="primary-cell-next-test-notification text-center"
                      style="width: 5%"
                      >{{ $t("reusable.common.startDate") }}</b-th
                    >
                    <b-th
                      class="primary-cell-next-test-notification text-center"
                      style="width: 5%"
                      >{{ $t("reusable.common.endDate") }}</b-th
                    >
                    <b-th
                      class="primary-cell-next-test-notification text-center"
                      style="width: 5%"
                    >
                      {{ $t("dashboard.dashboardView.editDates") }}
                    </b-th>
                  </b-tr>
                </b-thead>

                <b-tbody>
                  <template v-for="test in filterNextEvaluationNotification">
                    <b-tr :key="test.id">
                      <!-- Nombre de la Evaluacion (Evaluacion) -->
                      <b-td
                        class="secondary-cell-next-test-notification text-left"
                      >
                        <div class="mr-0">
                          {{ test.evaluation_title }}
                        </div>
                      </b-td>
                      <!-- Nombre de la Evaluacion (Test) -->
                      <b-td
                        class="secondary-cell-next-test-notification text-left"
                      >
                        <span
                          class="div-href-test"
                          @click="
                            redirectToTestTeacher(test.evaluation_id, test.id)
                          "
                          v-b-tooltip.v-secondary.top.noninteractive="
                            $t('dashboard.dashboardView.goToThe', {
                              entity: $getVisibleNames(
                                'evaluations2.evaluation',
                                false,
                                'Evaluación'
                              ),
                            })
                          "
                        >
                          {{ test.title }}
                        </span>
                      </b-td>
                      <!-- Sede -->
                      <b-td
                        class="secondary-cell-next-test-notification text-left"
                      >
                        {{ test.campus }}
                      </b-td>
                      <!-- Carrera -->
                      <b-td
                        class="secondary-cell-next-test-notification text-left"
                      >
                        {{ test.career_name }}
                      </b-td>
                      <!-- Asignatura -->
                      <b-td
                        class="secondary-cell-next-test-notification text-left"
                      >
                        {{ test.matter_code }} - {{ test.matter_name }}
                      </b-td>
                      <!-- Seccion -->
                      <b-td
                        class="secondary-cell-next-test-notification text-left"
                      >
                        {{ test.section_name }}
                      </b-td>
                      <!-- Fecha de Inicio -->
                      <b-td
                        class="secondary-cell-next-test-notification text-left"
                      >
                        <template v-if="test.start_time">
                          {{ test.start_time | FormatToDateTime }}
                        </template>
                        <template v-else>
                          {{ $t("reusable.common.notApplicable") }}
                        </template>
                      </b-td>
                      <!-- Fecha de Termino -->
                      <b-td
                        class="secondary-cell-next-test-notification text-left"
                      >
                        <template v-if="test.end_time">
                          {{ test.end_time | FormatToDateTime }}
                        </template>
                        <template v-else>
                          {{ $t("reusable.common.notApplicable") }}
                        </template>
                      </b-td>
                      <!-- Opciones -->
                      <b-td class="secondary-cell-next-test-notification">
                        <!-- Botón 3 puntos que abre popover -->
                        <div>
                          <button-edit
                            variant="secondary"
                            v-b-tooltip.v-secondary.left.noninteractive="
                              $t('dashboard.dashboardView.editStartAndEndDate')
                            "
                            @click="
                              $bvModal.show(`modal-edit-instrument-${test.id}`)
                            "
                          ></button-edit>
                        </div>
                        <b-modal
                          :id="`modal-edit-instrument-${test.id}`"
                          :title="
                            $t('reusable.common.editTooltip', {
                              entity: $getVisibleNames(
                                'evaluations2.test',
                                false,
                                'Instrumento'
                              ),
                            })
                          "
                          hide-footer
                          size="xl"
                        >
                          <NewInstrumentForm
                            :evaluation_id="test.evaluation_id"
                            :Instrument="new_tests.find((x) => x.id == test.id)"
                            :ClosedEvaluatee="existEvaluateeTest(test.id)"
                            :locked_instrument="test.is_locked"
                            :show_delete_button="false"
                            :fetch_questions="true"
                            @closeModal="changeInstrumentForm(test)"
                          ></NewInstrumentForm>
                        </b-modal>
                      </b-td>
                    </b-tr>
                  </template>
                </b-tbody>
              </b-table-simple>
            </template>
          </b-modal>
        </template>
      </div>
    </div>
    <!-- Modal -->
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "NewDashboard",
  components: {
    Card: () => import("./Card"),
    DirectiveDashboard: () =>
      import("@/components/users/DashboardCards/DirectiveDashboard"),
    DashboardEgressProfile: () =>
      import("@/components/users/DashboardCards/DashboardEgressProfile"),
    DashboardActiveMatters: () =>
      import("@/components/users/DashboardCards/DashboardActiveMatters"),
    InstrumentCorrection: () =>
      import("@/components/users/DashboardCards/InstrumentCorrection"),
    NextTestTeacher: () =>
      import("@/components/users/DashboardCards/NextTestTeacher"),
    NextTestStudent: () =>
      import("@/components/users/DashboardCards/NextTestStudent"),
    CurrentSectionTeacher: () =>
      import("@/components/users/DashboardCards/CurrentSectionTeacher"),
    CurrentSectionStudent: () =>
      import("@/components/users/DashboardCards/CurrentSectionStudent"),
    NewInstrumentForm: () =>
      import("@/components/new-evaluations/Evaluation/NewInstrumentForm"),
    PublishTestStudent: () =>
      import("@/components/users/DashboardCards/PublishTestStudent"),
    PastSectionTeacher: () =>
      import("@/components/users/DashboardCards/PastSectionTeacher"),
    PastSectionStudent: () =>
      import("@/components/users/DashboardCards/PastSectionStudent"),
    // PublishTestTeacher: () =>
    //   import("@/components/users/DashboardCards/PublishTestTeacher"),
  },
  data() {
    return {
      // Dashboard del profesor: pestaña activa y contadores (KPIs)
      activeTeacherTab: "notifications",
      teacherCounts: {
        notifications: 0,
        current: 0,
        next: 0,
        correct: 0,
        past: 0,
      },
      // Dashboard del estudiante
      activeStudentTab: "next",
      studentCounts: { current: 0, next: 0, finished: 0, past: 0 },
      // Dashboard del directivo: pestaña activa, contadores (KPIs) y grupos
      // que pueden verlo (misma lógica que tenía DirectiveDashboard).
      activeDirectiveTab: "egress",
      directiveCounts: { careers: 0, egress: 0, matters: 0 },
      directive_groups: [
        "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
        "DIRECTIVOS ACADÉMICOS (CAMPUS)",
        "DIRECTIVOS FACULTAD O ESCUELA",
        "DIRECTORES DE CARRERA",
        "DIRECTORES DE CARRERA (CAMPUS)",
        "ADMINISTRATIVOS INSTRUCCIONALES",
      ],
      next_evaluation_teacher: [],
      next_evaluation_teacher_notification: [],
      select_matter_notification_test: null,
      select_career_notification_test: null,
      select_section_correct_test: null,
      select_campus_notification_test: null,
      optionsMatterNotificationTest: [],
      optionsCareerNotificationTest: [],
      optionsSectionNotificationTest: [],
      optionsCampuNotificationTest: [],
      key_notification: 0,
      key_notification_instrument_correction: 0,
      textFromVue2: "Enviando data desde vue2 a vue3",
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      new_tests: names.NEW_TESTS,
      evaluatee_tests: names.EVALUATEE_TESTS,
    }),
    // Pestañas/KPIs del dashboard del profesor
    teacherTabs() {
      return [
        {
          key: "notifications",
          icon: "bell",
          label: this.$t("dashboard.dashboardView.attentionNotifications"),
        },
        {
          key: "next",
          icon: "calendar3",
          label: this.$t("dashboard.dashboardView.next", {
            entity: this.$getVisibleNames(
              "evaluations2.evaluation",
              true,
              "Evaluaciones"
            ),
          }),
        },
        {
          key: "correct",
          icon: "file-earmark-check",
          label: this.$t("dashboard.dashboardView.toCorrect", {
            entity: this.$getVisibleNames(
              "evaluations2.evaluation",
              true,
              "Evaluaciones"
            ),
          }),
        },
        {
          key: "current",
          icon: "journal-text",
          label: this.$t("dashboard.dashboardView.myClasses"),
        },
        {
          key: "past",
          icon: "journal-text",
          label: this.$t("dashboard.dashboardView.pastClasses"),
        },
      ];
    },
    // Pestañas/KPIs del dashboard del estudiante
    studentTabs() {
      return [
        {
          key: "next",
          icon: "calendar3",
          label: this.$t("dashboard.dashboardView.next", {
            entity: this.$getVisibleNames(
              "evaluations2.evaluation",
              true,
              "Evaluaciones"
            ),
          }),
        },
        {
          key: "finished",
          icon: "calendar3",
          label: this.$t("dashboard.dashboardView.finished", {
            entity: this.$getVisibleNames(
              "evaluations2.evaluation",
              true,
              "Evaluaciones"
            ),
          }),
        },
        {
          key: "current",
          icon: "journal-text",
          label: this.$t("dashboard.dashboardView.myClasses"),
        },
        {
          key: "past",
          icon: "journal-text",
          label: this.$t("dashboard.dashboardView.pastClasses"),
        },
      ];
    },
    // Grupos con un rol académico definido (directivos, docentes, estudiantes).
    // Un usuario que no pertenece a ninguno de estos recibe el mensaje de
    // bienvenida a la plataforma.
    knownRoleGroups() {
      return [...this.directive_groups, "PROFESORES", "ESTUDIANTES"];
    },
    // Mensaje de bienvenida para usuarios sin un rol académico específico
    // (no directivos/docentes/estudiantes y no superusuario).
    showWelcomeMessage() {
      if (!this.user) return false;
      if (this.user.is_superuser) return false;
      return !this.knownRoleGroups.some((group) =>
        this.user.group_names.includes(group)
      );
    },
    // ¿El usuario puede ver el dashboard del directivo? (directivos o superuser)
    showDirectiveDashboard() {
      if (!this.user) return false;
      return (
        this.directive_groups.some((group) =>
          this.user.group_names.includes(group)
        ) || this.user.is_superuser
      );
    },
    directiveTabs() {
      const isDuoc =
        this.institution && this.institution.internal_use_id == "duoc.cl";
      return [
        {
          key: "egress",
          icon: "journal-bookmark-fill",
          label: this.$getVisibleNames(
            "mesh.egressprofile",
            true,
            "Perfiles de Egreso"
          ),
          show: true,
        },
        {
          key: "matters",
          icon: "journal-bookmark-fill",
          label: this.$getVisibleNames(
            "mesh.egressprofilematter",
            false,
            "Asignatura"
          ),
          show: true,
        },
        {
          key: "careers",
          icon: "journal-text",
          label: this.$t("dashboard.directiveDashboard.title", {
            entity1: this.$getVisibleNames(
              "mesh.egressprofile",
              true,
              "Perfiles de Egreso"
            ),
            entity2: this.$getVisibleNames(
              "teaching.section",
              true,
              "Secciones"
            ),
          }),
          show: !isDuoc,
        },
      ].filter((tab) => tab.show);
    },
    filterNextEvaluationNotification() {
      let list = this.next_evaluation_teacher_notification;
      if (this.select_campus_notification_test) {
        list = list.filter(
          (x) => x.campus_id == this.select_campus_notification_test
        );
      }
      if (this.select_career_notification_test) {
        list = list.filter(
          (x) => x.career_id == this.select_career_notification_test
        );
      }
      if (this.select_matter_notification_test) {
        list = list.filter(
          (x) => x.matter_id == this.select_matter_notification_test
        );
      }
      if (this.select_section_correct_test) {
        list = list.filter(
          (x) => x.section_id == this.select_section_correct_test
        );
      }
      return list;
    },
  },
  methods: {
    // handleSendContent(content) {
    //   console.log("Contenido recibido desde Vue 3:", content.detail);
    // },
    optionsMattersNotificationTest(mattersFromApi) {
      this.optionsMatterNotificationTest = [
        {
          value: null,
          text: `${this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames(
              "mesh.egressprofilematter",
              false,
              "Asignatura"
            ),
          })}`,
        },
      ];
      // Crear un Map para almacenar carreras únicas
      const uniqueMatters = new Map();
      // Iterar sobre los datos de la API y llenar el Map
      mattersFromApi.forEach((x) => {
        if (!uniqueMatters.has(x.matter_name)) {
          uniqueMatters.set(x.matter_name, x.matter_id);
        }
      });
      // Convertir el Map en un array de opciones y añadirlo a optionsMatterNotificationTest
      uniqueMatters.forEach((id, name) => {
        this.optionsMatterNotificationTest.push({
          value: id,
          text: name,
        });
      });
    },
    optionsCareersNotificationTest(careersFromApi) {
      this.optionsCareerNotificationTest = [
        {
          value: null,
          text: `${this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames("mesh.career", false, "Programa"),
          })}`,
        },
      ];
      const uniqueCareers = new Map();
      careersFromApi.forEach((x) => {
        if (!uniqueCareers.has(x.career_name)) {
          uniqueCareers.set(x.career_name, x.career_id);
        }
      });
      uniqueCareers.forEach((id, name) => {
        this.optionsCareerNotificationTest.push({
          value: id,
          text: name,
        });
      });
    },
    optionsSectionsNotificationTest(sectionsFromApi) {
      this.optionsSectionNotificationTest = [
        {
          value: null,
          text: `${this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames("teaching.section", false, "Sección"),
          })}`,
        },
      ];
      const uniqueSections = new Map();
      sectionsFromApi.forEach((x) => {
        if (!uniqueSections.has(x.section_name)) {
          uniqueSections.set(x.section_name, x.section_id);
        }
      });
      uniqueSections.forEach((id, name) => {
        this.optionsSectionNotificationTest.push({
          value: id,
          text: name,
        });
      });
    },
    optionsCampusNotificationTest(campusFromApi) {
      this.optionsCampuNotificationTest = [
        {
          value: null,
          text: `${this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames("mesh.campus", false, "Sede"),
          })}`,
        },
      ];
      const uniqueCampus = new Map();
      campusFromApi.forEach((x) => {
        if (!uniqueCampus.has(x.campus)) {
          uniqueCampus.set(x.campus, x.campus_id);
        }
      });
      uniqueCampus.forEach((id, name) => {
        this.optionsCampuNotificationTest.push({
          value: id,
          text: name,
        });
      });
    },
    existEvaluateeTest(test_id) {
      if (
        this.evaluatee_tests.filter(
          (x) =>
            x.test == test_id &&
            (x.start_time != null ||
              x.is_corrected ||
              x.finished_at ||
              x.is_finished ||
              x.is_published)
        ).length > 0
      )
        return true;
      else return false;
    },
    redirectToTestTeacher(evaluation_id, instrument_id = null) {
      this.$router.push({
        name: "NewEvaluationView",
        params: {
          evaluation_id: evaluation_id,
          instrument_id: instrument_id,
        },
      });
    },
    patchStudentCard() {
      if (this.user.is_student) {
        if (this.user.student_card == null) {
          const payload = {
            show_dashboard_scores: false,
            user: this.user.id,
          };
          this.$restful.Post(`/cideu/student-card/${payload}`);
        } else {
          const payload = {
            show_dashboard_scores:
              !this.user.student_card.show_dashboard_scores,
          };
          this.$restful
            .Patch(`/cideu/student-card/${this.user.student_card.id}/`, payload)
            .then((response) => {
              this.user.student_card.show_dashboard_scores =
                response.show_dashboard_scores;
              this.$store.commit("setUser", this.user);
            });
        }
      }
    },
    getNextEvaluationTeacherNotification() {
      if (this.user && this.user.group_names.includes("PROFESORES")) {
        this.$restful
          .Get(`/evaluations2/dashboard_teacher_next_tests/?has_dates=${false}`)
          .then((response) => {
            this.next_evaluation_teacher_notification = response;
            this.teacherCounts.notifications = response.length;
            this.optionsMattersNotificationTest(response);
            this.optionsCareersNotificationTest(response);
            this.optionsSectionsNotificationTest(response);
            this.optionsCampusNotificationTest(response);
            this.key_notification += 1;
            let test_ids = [...new Set(response.map((x) => x.evaluation_id))];
            this.$store.dispatch(names.FETCH_NEW_TESTS, {
              evaluations_ids: test_ids,
            });
            this.$store.dispatch(names.FETCH_EVALUATEE_TESTS, {
              tests_ids: test_ids,
            });
            this.$store.dispatch(names.FETCH_NEW_TEST_TYPES);
          });
      }
    },
    changeInstrumentForm(test) {
      this.getNextEvaluationTeacherNotification();
      this.key_notification_instrument_correction += 1;
      this.$bvModal.hide(`modal-edit-instrument-${test.id}`);
    },
  },
  mounted() {
    this.getNextEvaluationTeacherNotification();
  },
  watch: {
    user() {
      this.getNextEvaluationTeacherNotification();
    },
  },
  created() {
    this.$hasPermissions();
  },
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
/* ===== Mensaje de bienvenida (estándar styles_kl.css · design tokens --kl-*) ===== */
/* Wrapper: centra la tarjeta vertical y horizontalmente en el área disponible */
.kl-welcome-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 65vh;
  width: 100%;
  padding: var(--kl-space-4);
}
.kl-welcome {
  width: 100%;
  max-width: 600px;
  padding: var(--kl-space-6);
  background: var(--kl-surface);
  border: 1px solid var(--kl-card-border);
  border-radius: var(--kl-card-radius);
  box-shadow: var(--kl-card-shadow);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
/* Badge circular con el color de marca */
.kl-welcome__badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 84px;
  height: 84px;
  margin-bottom: var(--kl-space-4);
  border-radius: 50%;
  background: var(--kl-color-accent-soft);
  color: var(--kl-color-primary);
  font-size: 2.25rem;
  line-height: 1;
}
.kl-welcome__title {
  font-family: var(--kl-font-family);
  font-size: var(--kl-fs-title-md);
  font-weight: var(--kl-fw-bold);
  line-height: var(--kl-lh-tight);
  color: var(--kl-text-heading);
  margin: 0;
}
/* Divisor decorativo bajo el título */
.kl-welcome__divider {
  width: 64px;
  height: 4px;
  margin: var(--kl-space-3) 0 var(--kl-space-4);
  border-radius: var(--kl-radius-pill);
  background: var(--kl-color-primary);
}
.kl-welcome__text {
  font-family: var(--kl-font-family);
  font-size: var(--kl-fs-body);
  font-weight: var(--kl-fw-regular);
  line-height: var(--kl-lh-base);
  color: var(--kl-text-body);
  margin-bottom: 0;
  max-width: 42ch;
}
/* Indicación sobre el menú lateral izquierdo */
.kl-welcome__hint {
  display: flex;
  align-items: center;
  gap: var(--kl-space-2);
  margin-top: var(--kl-space-5);
  padding: var(--kl-space-3) var(--kl-space-4);
  background: var(--kl-color-accent-soft);
  border: 1px solid var(--kl-color-accent-border);
  border-radius: var(--kl-radius-md);
  font-family: var(--kl-font-family);
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-semibold);
  line-height: var(--kl-lh-base);
  color: var(--kl-color-accent-medium);
  text-align: left;
}
.kl-welcome__hint-icon {
  flex-shrink: 0;
  font-size: 1.1rem;
  color: var(--kl-color-primary);
}
.container-title-my-classes {
  display: flex;
  justify-content: space-between;
}
.primary-cell-my-classes {
  vertical-align: middle;
  background-color: #80e98e;
  color: black !important;
  font-size: var(--primary-font-size);
  padding: 2px 2px;
}
.secondary-cell-my-classes {
  text-align: center;
  vertical-align: middle;
  font-size: var(--secondary-font-size);
  padding: 2px 2px;
}
.primary-cell-next-test {
  vertical-align: middle;
  background-color: #d8a899;
  color: black !important;
  font-size: var(--primary-font-size);
  padding: 2px 2px;
}
.secondary-cell-next-test {
  text-align: center;
  vertical-align: middle;
  font-size: var(--secondary-font-size);
  padding: 2px 2px;
}
.primary-cell-correction-test {
  vertical-align: middle;
  background-color: rgba(233, 117, 8, 0.3);
  color: black !important;
  font-size: var(--primary-font-size);
  padding: 2px 2px;
}
.secondary-cell-correction-test {
  text-align: center;
  vertical-align: middle;
  font-size: var(--secondary-font-size);
  padding: 2px 2px;
}
/* Modal de Notificaciones del profesor: encabezado y celdas según el
   estándar de diseño (styles_kl.css), igual a las tablas del dashboard */
.primary-cell-next-test-notification {
  vertical-align: middle;
  background: var(--kl-table-header-bg) !important;
  color: var(--kl-table-header-text) !important;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-table-header-fs);
  text-transform: uppercase;
  letter-spacing: var(--kl-ls-wide);
  padding: 11px 12px !important;
  border: none !important;
  white-space: normal;
}
.secondary-cell-next-test-notification {
  text-align: center;
  vertical-align: middle;
  color: var(--kl-table-text);
  font-size: var(--kl-table-fs);
  padding: 11px 12px !important;
  border: none !important;
  border-bottom: 1px solid var(--kl-border-soft) !important;
}
/* Contenedor de la tabla del modal: esquinas redondeadas + filas alternadas */
.border-table-notification {
  border-radius: var(--kl-table-radius);
  border: 1px solid var(--kl-table-border);
}
.border-table-notification >>> table {
  margin-bottom: 0;
}
.border-table-notification >>> tbody tr > td {
  background-color: var(--kl-table-row-bg);
}
.border-table-notification >>> tbody tr:nth-child(even) > td {
  background-color: var(--kl-table-row-alt-bg);
}
.border-table-notification >>> tbody tr:hover > td {
  background-color: var(--kl-table-row-hover-bg);
}
.div-href-test {
  color: var(--kl-color-accent);
}
.notification-text {
  margin-top: 0.15rem;
  margin-left: 0.05rem;
}
.div-href-test:hover {
  color: var(--kl-color-primary-hover) !important;
  text-decoration: underline;
  cursor: pointer;
}
.border-table {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.dashboard-container {
  display: flex;
  flex-direction: column;
}
.left-container {
  width: 100%;
}
/* Notificaciones, Anuncios, Mensajes y Recursos: una fila de 4 columnas
(una por sección) a ancho completo. */
.right-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  align-items: start;
}
.right-container .dashboard-card {
  margin-top: 0;
}
@media (max-width: 992px) {
  .right-container {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 576px) {
  .right-container {
    grid-template-columns: 1fr;
  }
}
/* ===== Dashboard del profesor: resumen (KPIs) + pestañas ===== */
.teacher-dash {
  margin-bottom: 18px;
}
/* Tile de acción "Mis Notas" en el kpi-row del estudiante (navega, es un CTA) */
.kpi-tile.kpi-tile--action {
  background: var(--kl-color-accent-soft) !important;
  border-color: transparent !important;
  color: #000;
  align-items: center;
  justify-content: center;
  text-align: left;
}
.kpi-tile.kpi-tile--action .kpi-tile__icon {
  color: var(--kl-text-heading);
}
.kpi-tile.kpi-tile--action .kpi-tile__action-text {
  font-size: 0.95rem;
  font-weight: var(--kl-fw-bold);
  color: var(--kl-text-heading);
}
.kpi-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
@media (max-width: 992px) {
  .kpi-row {
    grid-template-columns: repeat(3, 1fr);
  }
}
.kpi-tile {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 12px 14px;
  border: 1px solid var(--kl-border);
  border-radius: var(--kl-radius-lg);
  background: var(--kl-surface);
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.kpi-tile:hover {
  border-color: #cfe0ee;
  box-shadow: 0 2px 4px rgba(16, 38, 73, 0.08);
}
.kpi-tile.is-active {
  border-color: var(--kl-color-primary);
  box-shadow: 0 2px 4px rgba(0, 110, 200, 0.15);
}
.kpi-tile__icon {
  color: var(--kl-text-muted);
  font-size: 1.1rem;
}
.kpi-tile.is-active .kpi-tile__icon {
  color: var(--kl-color-primary);
}
.kpi-tile__value {
  font-size: 1.6rem;
  font-weight: var(--kl-fw-bold);
  line-height: 1.1;
  color: var(--kl-text-heading);
}
.kpi-tile__label {
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-semibold);
  color: var(--kl-text-muted);
}
@media (max-width: 768px) {
  .kpi-row {
    grid-template-columns: repeat(2, 1fr);
  }
}
.dashboard-card {
  display: block;
  border-radius: 7px;
  margin-top: 5px;
  margin-bottom: 15px;
  /* box-shadow: 0px 1px 5px 0px #9d9d9d; */
  transition: all 0.5s ease-out;
}
.div-href {
  color: var(--kl-color-accent);
}
.div-href:hover {
  color: var(--kl-color-primary-hover) !important;
  text-decoration: underline;
  cursor: pointer;
}
.container-select {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
}
.container-select > div {
  flex: 1 1 calc(25% - 10px);
  min-width: 200px;
}
/* Selects de filtro según el estándar (--kl-input-*) */
.select-form {
  width: 100%;
  height: 40px;
  font-size: var(--kl-fs-body);
  color: var(--kl-text-heading);
  border: 1px solid var(--kl-border-soft) !important;
  border-radius: var(--kl-input-radius) !important;
  background-color: var(--kl-surface);
}
.select-form:focus {
  border-color: var(--kl-color-primary) !important;
  box-shadow: 0 0 0 3px rgba(0, 110, 200, 0.15) !important;
}
@media (max-width: 991px) {
  .dashboard-container {
    display: block !important;
  }
  .left-container,
  .right-container {
    width: 100%;
  }
  .notification-dashboard {
    margin-left: 0% !important;
    margin-right: 10% !important;
  }
}
@media only screen and (min-width: 701px) and (max-width: 980px) {
  .notification-dashboard {
    margin-left: 0% !important;
    margin-right: 10% !important;
  }

  .container-select > div {
    flex: 1 1 calc(50% - 10px);
  }
}
@media only screen and (max-width: 700px) {
  .notification-dashboard {
    margin-left: 0% !important;
    margin-right: 5% !important;
  }
}

@media only screen and (max-width: 620px) {
  .notification-dashboard {
    margin-left: 0% !important;
    margin-right: 5% !important;
  }
  .container-select > div {
    flex: 1 1 100%;
  }
}
</style>